<template>
  <div class="artwork-item d-flex">
    <div class="">
      <div class="image_wrapper">
        <el-image
          :src="
            form.displayImageUrl
              ? $osscdn(form.displayImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          @click="onPreview"
          class="image"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" class="image" />
          </div>
        </el-image>
      </div>
      <div class="mt-4 opt-buttons">
        <div class="icon-button" @click="onDelete">
          <i class="el-icon-delete text-danger font-weight-bold"></i>
        </div>
      </div>
    </div>
    <div class="right ml-2 w-100">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="80px"
        size="mini"
        label-position="top"
      >
        <el-row :gutter="15">
          <el-col :span="18">
            <el-form-item
              :label="$l('form_label_fileName') || '文件名称'"
              prop="fileName"
            >
              <el-input
                v-model="form.fileName"
                :placeholder="
                  $l('form_placeholder_uploadFile') || '请上传图片文件'
                "
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_fileSize') || '文件大小'"
              prop="fileSize"
              v-if="!form.isNew"
            >
              <el-input v-model="form.v_fileSize" readonly></el-input>
            </el-form-item>
            <div style="height: 28px;" v-if="form.isNew"></div>
            <div v-if="form.isNew">
              <el-upload
                class="upload-demo"
                ref="uploader"
                action="#"
                :auto-upload="false"
                :on-change="handleChange"
                :file-list="fileList"
                :show-file-list="false"
                accept=".jpeg,.jpg,.png,.gif"
              >
                <el-button size="mini" type="primary">{{
                  $l('button_text_upload_file') || '点击上传'
                }}</el-button>
              </el-upload>
            </div>
          </el-col>
        </el-row>

        <el-form-item
          :label="$l('form_label_file_desc') || '文件说明'"
          prop="imgDesc"
        >
          <el-input
            v-model="form.imgDesc"
            :readonly="form.readonly"
            :placeholder="$l('form_placeholder_file_desc') || '请输入文件说明'"
            type="textarea"
            :rows="2"
            show-word-limit
            clearable
            maxlength="500"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="d-flex justify-content-between align-items-center">
        <div class="text-secondary flex-fill" style="font-size: 12px;">
          <span v-if="form.modifyDate">
            Modify by:{{ item.modifyByName }} at {{ form.modifyDate }}
          </span>
        </div>
        <div class="d-flex">
          <div v-if="form.readonly" class="mx-2 d-flex">
            <div class="icon-button" @click="onPreview">
              <i class="fa fa-eye"></i>
            </div>
            <div class="icon-button" @click="onDownload">
              <i class="el-icon-download"></i>
            </div>
          </div>
          <el-button
            v-if="form.readonly"
            type="primary"
            size="mini"
            @click="onEdit"
            >{{ $l('button_text_edit_desc') || '编辑说明' }}</el-button
          >
          <el-button v-else type="success" size="mini" @click="onSave">{{
            $l('button_text_confirm_upload') || '确认上传'
          }}</el-button>
        </div>
      </div>
    </div>
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in [form.displayImageUrl]"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    currIndex: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      form: {},
      rules: {
        fileName: [
          {
            required: true,
            message: this.$l('form_placeholder_uploadFile') || '请上传图片文件',
            trigger: 'change',
          },
          {
            required: true,
            message: this.$l('form_placeholder_uploadFile') || '请上传图片文件',
            trigger: 'change',
          },
        ],
        imgDesc: [
          {
            required: true,
            message: this.$l('form_placeholder_file_desc') || '请输入文件说明',
            trigger: 'blur',
          },
        ],
      },
      imageUrl: '',
      fileList: [],
      readonly: true,
    }
  },
  watch: {
    item: {
      handler(val) {
        this.form = { ...val }
        if (val.fileSize) {
          this.form.v_fileSize = this.calFileSize(val.fileSize)
        }
      },
      immediate: true,
    },
    form: {
      handler(val) {
        this.$emit('change', val)
      },
      deep: true,
    },
  },
  methods: {
    handleChange(file) {
      if (file.status !== 'ready') {
        return
      }
      this.form = {
        ...this.form,
        fileName: file.name,
        fileSize: file.size,
        file: file.raw,
        v_fileSize: this.calFileSize(file.size),
        displayImageUrl: URL.createObjectURL(file.raw),
      }
      this.fileList = [file]
    },
    calFileSize(size) {
      const kbsize = ((size || 0) / 1024).toFixed(2)
      let mbSize = 0
      if (kbsize >= 1024) {
        mbSize = (kbsize / 1024).toFixed(2)
      }
      return mbSize > 0 ? mbSize + 'MB' : kbsize + 'KB'
    },
    onPreview() {
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.view(0)
      viewer.show()
    },
    onDownload() {
      window.open(this.item.originImageUrl)
    },
    onDelete() {
      this.$emit('delete', this.currIndex)
    },
    onEdit() {
      this.form.readonly = false
    },
    async onSave() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      this.$emit('save', this.form)
    },
  },
}
</script>
<style lang="scss" scoped>
.image_wrapper {
  width: 100px;
  height: 100px;
  border-radius: 5px;
  border: 1px solid #bbbbbb;
  margin-right: 10px;
}
.image {
  width: 98px;
  height: 98px;
  border-radius: 5px;
}
.artwork-item {
  background-color: rgba(244, 246, 249, 1);
  padding: 20px;
}
.opt-buttons {
  display: flex;
  justify-content: center;
}
.icon-button {
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.icon-button i {
  font-size: 20px;
}
::v-deep {
  .el-upload--text {
    width: 100%;
    .el-button {
      width: 100%;
    }
  }
}
</style>
